import React from "react";
import CustomFonts from "../components/custom-fonts/custom-fonts";
import Footer from "../components/footer/footer";
import Header from "../components/header/header";
import MainContent from "../components/main-content/main-content";
// import Seo from "../components/seo";
import Sidebar from "../components/sidebar/sidebar";

const IndexPage = () => {
  const players = {
    player1: { name: "Masa", image: "masa" },
    player2: { name: "Michael", image: "michael" },
  };

  const history = [
    { date: "2021-08-14", time: "14:00", player1: 0, player2: 6 },
    { date: "2021-08-16", time: "15:00", player1: 3, player2: 6 },
    { date: "2021-08-17", time: "16:00", player1: 0, player2: 6 },
    { date: "2021-08-19", time: "16:00", player1: 6, player2: 3 },
    { date: "2021-08-21", time: "16:00", player1: 7, player2: 5 },
    { date: "2021-08-21", time: "16:00", player1: 6, player2: 7 },
    { date: "2021-08-21", time: "16:00", player1: 0, player2: 6 },
    { date: "2021-08-25", time: "15:00", player1: 5, player2: 7 },
    { date: "2021-08-28", time: "15:00", player1: 2, player2: 6 },
    { date: "2021-08-28", time: "15:00", player1: 3, player2: 6 },
    { date: "2021-09-03", time: "15:00", player1: 6, player2: 7 },
  ];

  return (
    <div className="antialiased bg-back leading-normal font-text text-front">
      {/* <Seo title="Masa vs Michael" /> */}
      <CustomFonts />
      <Header />
      <div className="md:max-w-screen-sm lg:max-w-screen-xl mx-auto px-4 flex flex-wrap">
        <Sidebar players={players} />
        <MainContent players={players} history={history} />
      </div>
      <Footer />
    </div>
  );
};

export default IndexPage;
